import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@material-ui/core/Button';
import Dialog from 'components/DialogWrapper/DialogWrapper';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import DialogHeader from 'components/DialogHeader/DialogHeader';
import Spinner from 'components/Spinner/Spinner';
import TextInput from 'components/TextInput/TextInput';
import ButtonLoading from 'components/ButtonLoading/ButtonLoading';

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    ...theme.component.dialogPaper,
    border: theme.component.border,
    [theme.breakpoints.down('xs')]: {
      marginLeft: 24,
      marginRight: 24,
    },
  },
  dialogContent: {
    paddingTop: 16,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
  imageGrid: {
    alignItems: 'center',
    display: 'flex',
    flexGrow: 1,
    justifyContent: 'center',
    maxWidth: '300px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  image: {
    maxWidth: '100%',
    height: 'auto',
  },
}));

function DescriptionDialog(props) {
  const theme = useTheme();
  const { picture } = props;
  const [src, setSrc] = useState(null);
  const [description, setDescription] = useState(picture.description);
  const classes = useStyles();
  const { t } = useTranslation('common');

  const handleSave = () => {
    const pictureData = {
      description: description || '',
    };
    props.onSave(pictureData);
  };

  return (
    <Dialog
      aria-labelledby="project-bank-preview-dialog"
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={props.onClose}
    >
      <DialogHeader title={picture.name} onClose={props.onClose} />
      <DialogContent className={classes.dialogContent}>
        <Grid
          container
          spacing={2}
          direction="column"
          className={classes.gridContainer}
        >
          <Grid item className={classes.tableGrid}>
            <TextInput
              defaultValue={picture.description ? picture.description : null}
              fullWidth
              id="pictureDescriptionInput"
              onChange={(e) => setDescription(e.target.value)}
              label={t('file.edit_description')}
              margin="dense"
              type="text"
              disabled={props.loading}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button disabled={props.loading} onClick={props.onClose}>
          {t('common.cancel')}
        </Button>
        <Button disabled={props.loading} onClick={handleSave}>
          {!props.loading ? (
            t('common.save')
          ) : (
            <ButtonLoading />
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

DescriptionDialog.defaultProps = {
  picture: {
    name: '',
    description: '',
    createdAt: '',
    key: '',
  },
};

DescriptionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  picture: PropTypes.object.isRequired,
  project: PropTypes.object.isRequired,
  loading: PropTypes.bool,
};

export default DescriptionDialog;
